import React from "react";
import Funnel from "../charts/Funnel";
import BarChart from "../charts/BarChart";
import KPIBox from "../KPIBox";
var GgSiteConversionsCampaign = function (_a) {
    var campaign = _a.campaign, insights = _a.insights;
    var current_insight = (insights === null || insights === void 0 ? void 0 : insights.current) || {};
    var previous_insight = (insights === null || insights === void 0 ? void 0 : insights.previous) || {};
    var current_actions = current_insight.actions || [];
    var previous_actions = previous_insight.actions || [];
    // Funil
    var funnelData = [
        {
            label: "Visualizações",
            value: current_insight.impressions
                ? Number(current_insight.impressions)
                : null,
            previous: previous_insight.impressions
                ? Number(previous_insight.impressions)
                : null,
            color: "#b6ff00",
        },
        {
            label: "Cliques",
            value: previous_insight.clicks,
            previous: current_insight.clicks,
            color: "#ffe600",
        },
        {
            label: "Contatos",
            value: previous_insight.conversions,
            previous: current_insight.conversions,
            color: "#00e1ff",
        },
        {
            label: "Vendas",
            value: "?",
            previous: "?",
            color: "#ff2d2d",
        },
    ];
    // Normaliza os dados para garantir que são números
    // const normalizedResultsByDay = Object.fromEntries(
    //   Object.entries(insights?.results_by_day || {}).map(([date, data]: [string, any]) => [
    //     date,
    //     {
    //       clicks: Number(data.clicks ?? 0),
    //       conversions: Number(data.conversions ?? 0),
    //     },
    //   ])
    // );
    // Extrai os dados diários do backend
    var resultsByDay = (insights === null || insights === void 0 ? void 0 : insights.results_by_day) || {};
    // console.log("Results by day Google:", insights);
    // // console.log("Results by day Google:", resultsByDay);
    return (React.createElement("div", { className: "bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-0" },
        React.createElement("div", { className: "max-w-7xl mx-auto px-4 py-6 " },
            React.createElement("div", { className: "grid gap-6", style: { gridTemplateColumns: "1fr 4fr" } },
                React.createElement("div", { className: "col-span-1 flex flex-col items-center justify-start" },
                    React.createElement(Funnel, { data: funnelData })),
                React.createElement("div", { className: "col-span-1 flex flex-col items-center" },
                    React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-6 mb-8 w-full", style: { height: 340 } },
                        React.createElement("div", { className: "text-xs text-gray-400 mb-2" }, "Cliques x Convers\u00F5es por dia"),
                        React.createElement("div", { style: { width: "100%" } },
                            React.createElement(BarChart, { resultsByDay: resultsByDay, fields: [
                                    { key: "clicks", label: "Cliques no anúncio do Google", color: "#22d3ee", type: "bar" },
                                    { key: "conversions", label: "Conversões", color: "#fde047", type: "line", yAxisID: "y1" },
                                ], height: 280 }))))),
            React.createElement("div", { className: "grid gap-6", style: { gridTemplateColumns: " 4fr 1fr" } },
                React.createElement("div", { className: "col-span-1 flex flex-col items-center" },
                    React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-6 w-full", style: { height: 430 } },
                        React.createElement("div", { className: "text-xs text-gray-400 mb-2" }, "Custo por Contato x Investimento Di\u00E1rio"),
                        React.createElement("div", { style: { width: "100%" } },
                            React.createElement(BarChart, { resultsByDay: resultsByDay, fields: [
                                    { key: "cost_per_conversion", label: "Custo Por Contato", color: "#22d3ee", type: "bar" },
                                    { key: "cost", label: "Investimento Diário", color: "#fde047", type: "line", yAxisID: "y1" },
                                ], height: 380 })))),
                React.createElement("div", { className: "col-span-1 flex flex-col gap-4 justify-center" },
                    React.createElement(KPIBox, { label: "Investimento", value: current_insight === null || current_insight === void 0 ? void 0 : current_insight.cost, previous: previous_insight === null || previous_insight === void 0 ? void 0 : previous_insight.cost, prefix: "R$ ", decimals: 2 }),
                    React.createElement(KPIBox, { label: "CPC (Custo por Clique)", value: current_insight === null || current_insight === void 0 ? void 0 : current_insight.average_cpc, previous: previous_insight === null || previous_insight === void 0 ? void 0 : previous_insight.average_cpc, prefix: "R$ ", decimals: 2 }),
                    React.createElement(KPIBox, { label: "CTR (Taxa de clique)", value: current_insight === null || current_insight === void 0 ? void 0 : current_insight.ctr, previous: previous_insight === null || previous_insight === void 0 ? void 0 : previous_insight.ctr, decimals: 2 }),
                    React.createElement(KPIBox, { label: "Custo/Convers\u00E3o", value: current_insight === null || current_insight === void 0 ? void 0 : current_insight.cost_per_conversion, previous: previous_insight === null || previous_insight === void 0 ? void 0 : previous_insight.cost_per_conversion, prefix: "R$ ", decimals: 2 }))),
            React.createElement("div", { className: "grid gap-6" },
                React.createElement("div", { className: "col-span-1 flex flex-col items-center" },
                    React.createElement("div", { className: "w-full mb-4" }))))));
};
export default GgSiteConversionsCampaign;
